<template>
  <div class="header-nav bg-main">
    <div class="logo-box">
      <a
        @click.stop="$router.push('/').catch(() => {})"
        v-for="(logo,index) in logos"
        :key="index"
        class="brand-skip"
        href="javascript:;"
      >
        <img :src="logo.src[$i18n.locale] || ''" alt="logo">
      </a>
    </div>
    <div class="nav-box">
      <ul class="nav-list">
        <!-- 导航栏菜单 -->
        <!--<li v-for="menu in menus" :key="menu.index">
          <a class="fc-main" @click.stop="turnToRouterByType(menu)" href="javascript:;">
            {{ $t(`nav[${menu.index}]` ) }}
          </a>
        </li>-->
         <!--<li>
          <a class="fc-main" href="javascript:;">
            {{ $i18n.locale == 'zh'?'敬请期待':'Coming soon'}}
          </a>
        </li>-->
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'nav-header',
  data() {
    return {
      logos: [ // logo设置
        {
          router: '',
          src: {
            // eslint-disable-next-line
            zh: require('@/assets/image/logo/logo-zh.jpg'),
            // eslint-disable-next-line
            en: require('@/assets/image/logo/logo-zh.jpg'),
          },
        },
      ],
      menus: [ // 对应的菜单设置
        // { router: '/booking', index: 0 },
        // { router: '/discount', index: 1 },
        { router: '/booking/menu/default', index: 2 },
        // { router: '/club', index: 3 },
        { router: '/info-root/0', index: 4 },
      ],
    };
  },
  methods: {
    turnToRouterByType(menu) {
      if (menu.router === '/booking' && !this.$service.user.getUser().check()) {
        this.$parent.openLoginModal('/booking');
        return;
      }
      this.$router.push({ path: menu.router }).catch(() => {});
    },
  },
};

</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'
@import '../../assets/css/theme.sass'

.header-nav
  @include base-wrap
  position: initial
  height: 64px
  background-color: $bg_main
  display: flex
  justify-content: space-between
  .logo-box
    max-width: 420px
    height: 64px
    a
      display: inline-block
      width: 132px
      position: relative
      top: -45px
      left: 28px
      img
        height: 120px
        line-height: 210px
  .nav-box
    height: 64px
    .nav-list
      line-height: 73px
      padding-right: 10px
      li
        display: inline-block
        min-width: 100px
        height: 21px
        line-height: 21px
        border-left-color: transparent
        text-align: center
        &:not(:first-child)
          border-left: 2px solid #fff
        i[class^='icon-']
          display: block
          float: left
          width: 32px
          height: 32px
          margin: -2px 10px 0 46px
          // @include bg-url('~static/images/candao-web-v6/my_icon.png')
          @include bg-repeat
          @include bg-position(-15px 0px)
          &.icon-order-page
           @include bg-position(-15px 0px)
          &.icon-my-account
           @include bg-position(-15px -33px)
          &.icon-help-page
           @include bg-position(-15px -65px)
        a
          font-size: 20px
          color: #fff
          padding-right: 18px
          padding-left: 18px
</style>
